export const API_ENDPOINT_PATH = '/api/mongo';
export const API_HTTP_HEADERS = {
	'Content-Type': 'application/json',
	'Cache-Control': 'no-cache',
	'Pragma': 'no-cache',
};
